import { connect } from 'react-redux';
import Promotions from '../components/PromotionsComponent';
import { fetchAllPublishedPromotionsIfNeeded, fetchClosedPromotionsIfNeeded } from '../actions/PromotionsActions';


const mapStateToProps = (state) => ({
    breakpoint: state.breakpointReducer,
    allPublishedPromotions: state.promotions.mainPromotion.allPublishedPromotions,
    featuredPromotions: state.promotions.mainPromotion.featuredPromotions,
    closedPromotions: state.promotions.mainPromotion.closedPromotions,
    // filiaisWithPromotionsPublished: state.getIn(['promotions', 'mainPromotion', 'filiaisWithPromotionsPublished']),
    // isFetching: state.getIn(['promotions', 'mainPromotion', 'isFetching']),
    isTablet: state.clientInfo.isTablet,
});
const mapDispatchToProps = (dispatch) => ({
    fetchAllPublishedPromotionsIfNeeded: () => {
        dispatch(fetchAllPublishedPromotionsIfNeeded());
    },
    fetchClosedPromotionsIfNeeded: (limit = 32, start = 0) => {
        dispatch(fetchClosedPromotionsIfNeeded(limit, start));
    },
});
const PromotionsContainers = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Promotions);

export default PromotionsContainers;
